import React from 'react';
import { motion } from 'framer-motion';
import { KeyRound } from 'lucide-react';
const DEFAULT_CHECKOUT_URL = 'https://digifactorymax.net/cart/57874198823176:1';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
  checkoutUrl?: string;
  pixelValue?: number;
  variant?: 'orange' | 'green';
}
const VARIANT_CLASSES = {
  orange: 'bg-orange-500 hover:bg-orange-600 focus-visible:ring-orange-500',
  green: 'bg-green-600 hover:bg-green-700 focus-visible:ring-green-600'
} as const;
export function Button({
  children,
  className = '',
  fullWidth = false,
  showIcon = true,
  checkoutUrl,
  pixelValue = 6.36,
  variant = 'orange',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      // Fire Meta Pixel AddToCart event before redirect
      try {
        const fbq = (window as any).fbq;
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: 'The Ultimate Auction Secrets Blueprint 2026',
            content_ids: ['57874198823176'],
            content_type: 'product',
            value: pixelValue,
            currency: 'USD'
          });
        }
      } catch (err) {
        /* no-op */
      }
      window.location.href = checkoutUrl || DEFAULT_CHECKOUT_URL;
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative inline-flex items-center justify-center gap-3 
        ${VARIANT_CLASSES[variant]} text-white font-semibold 
        px-8 py-4 rounded-xl transition-colors shadow-md hover:shadow-lg
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-white
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-514">
      <span className="text-sm sm:text-lg tracking-wide text-center leading-tight whitespace-nowrap" data-id="element-515">
        {children}
      </span>
      {showIcon && <KeyRound className="w-5 h-5 shrink-0" data-id="element-516" />}
    </motion.button>;
}